
<ion-row>

  <ion-col size="3" style="padding-left: 10px;">
    <div class="formLabelRegularfs16   mb-5">
      Year<span class="red-cl">&nbsp;*</span></div>
    <mat-form-field class="w-100 mat-height40 mat-input-style">
      <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
        (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
        <mat-option [value]="item.year" *ngFor="let item of pmsYears">
          {{sharedService.transformYearToFyFormat(item.year)}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ion-col>
  <ion-col size="3">
    <div class="formLabelRegularfs16   mb-5">
      Month<span class="red-cl">&nbsp;*</span>
    </div>
    <mat-form-field class="mat-height40 w-100  mat-input-style">
      <mat-select placeholder="Select" [(ngModel)]="selectedMonth" (selectionChange)="onMonthChange($event)">
        <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
      </mat-select>
    </mat-form-field>

  </ion-col>

</ion-row>

<ion-row>
  <ion-col size-sm="6" size-md="3" size-lg="12" size-xs="6">
    <ion-row>
      <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
        <div class="card">
          <div class="d-flex">
            <div>
              <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
            </div>
            <ion-row>
              <ion-col size="12">
                <div class="text-center ml-30">
                  <p class="fs-12 font_semibold text-center">Opening Emp. Count</p>
                  <p class="mt-5 fs-12 font_bold Cerulean-Blue cp"> {{ openingCount ?? 0 }}
                  </p>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>
      </ion-col>

      <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
        <div class="card">
          <div class="d-flex">
            <div>
              <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
            </div>
            <ion-row>
              <ion-col size="12">
                <div class="text-center ml-30">
                  <p class="fs-12 font_semibold text-center">Closing Emp. Count</p>
                  <p class="mt-5 fs-12 font_bold Cerulean-Blue cp">{{closingCount ?? 0 }}</p>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>
      </ion-col>
      <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
        <div class="card">
          <div class="d-flex">
            <div>
              <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
            </div>
            <ion-row>
              <ion-col size="12">
                <div class="text-center ml-30">
                  <p class="fs-12 font_semibold text-center">Attrition Count</p>
                  <p class="mt-5 fs-12 font_bold Cerulean-Blue cp">{{attritionCount ?? 0 }}</p>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>
      </ion-col>

      <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
        <div class="card">
          <div class="d-flex">
            <div>
              <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
            </div>
            <ion-row>
              <ion-col size="12">
                <div class="text-center ml-30">
                  <p class="fs-12 font_semibold text-center">Attrition</p>
                  <!-- <p class="mt-5 fs-12 font_bold Cerulean-Blue cp">
                    {{attritionOpeningClosingPercentage ?? 0 }}%
                    ({{ loggedInCompanyFiscalyear === 'Jan_Dec' ? attrition12MonthJanDec : attrition12MonthAprilMarch ?? 0 
                    }}%)
                  </p> -->
                  <p class="mt-5 fs-12 font_bold Cerulean-Blue cp">
                    {{ attritionOpeningClosingPercentage ?? 0 }}%
                    ({{ loggedInCompanyFiscalyear === 'Jan_Dec'
                    ? (attrition12MonthJanDec ?? 0)
                    : (attrition12MonthAprilMarch ?? 0) }}%)
                  </p>

                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>
      </ion-col>
      <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
        <div class="card">
          <div class="d-flex">
            <div>
              <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
            </div>
            <ion-row>
              <ion-col size="12">
                <div class="text-center ml-30">
                  <p class="fs-12 font_semibold text-center">Avg. attrited emp age</p>
                  <p class="mt-5 fs-12 font_bold Cerulean-Blue cp">{{avgAttritedEmpAge ?? 0 }} yrs</p>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>
      </ion-col>

      <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
        <div class="card">
          <div class="d-flex">
            <div>
              <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
            </div>
            <ion-row>
              <ion-col size="12">
                <div class="text-center ml-30">
                  <p class="fs-12 font_semibold text-center">Avg. time of attrited emp</p>
                  <p class="mt-5 fs-12 font_bold Cerulean-Blue cp">
                    <!-- {{ avgAttritionTimeInCompany ? (avgAttritionTimeInCompany | json) : '0' }} yrs -->
                    {{formattedAttritionTime }} 
                  </p>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>
      </ion-col>

    </ion-row>
  </ion-col>


</ion-row>

<ion-row class="pt-10" size="12">
  <ion-col size="12">
    <div class="graphs m-50">
      <ion-row class="justify-content-center">
        <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
          <div class="fs-16 font_bold">Age Group & Gender</div>
        </ion-col>
        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div class="d-flex graph-icon">
            <span (click)="switchrepaiedAssetGraph('bar')">
              <img *ngIf="isRepairedByAssetIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
              <img *ngIf="isRepairedByAssetIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
            </span>
            <span (click)="switchrepaiedAssetGraphForTable()">
              <img *ngIf="!isRepairedByAssetTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
              <img *ngIf="isRepairedByAssetTable" src="././assets/icon/TableIconActive.svg" alt="">
            </span>
            <span (click)="switchrepaiedAssetGraph('line')">
              <img *ngIf="isRepairedByAssetIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="" class="cp">
              <img *ngIf="isRepairedByAssetIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
            </span>
            <span>
              <img (click)="downloadChartAsPDF('Age Group')" src="././assets/icon/downloadIcon.svg" alt="" class="cp">
            </span>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="">
        <ion-col size="5" size-md="5" size-lg="5" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col>
                  <!-- <div class="formLabelRegularfs16  ">
                    Year<span class="red-cl">&nbsp;*</span></div> -->
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                      (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col>
                  <!-- <div class="formLabelRegularfs16">
                    Month<span class="red-cl">&nbsp;*</span>
                  </div> -->
                  <mat-form-field class="mat-height40 w-100  mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedMonth"
                      (selectionChange)="onMonthChange($event)">
                      <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div [ngClass]="{'dispNone' : !isRepairedByAssetTable}">
          <div class="dashboardGraphTable">
            <table id="table-AgeGroup-data">
              <thead>
                <tr class="custom-size">

                  <th>Age</th>
                  <th>Male</th>
                  <th>Female</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of isAsseTableGraphTwo">

                  <td>{{data.xAxisValueData}}</td>
                  <td>{{data.seriesValueOneData}} </td>
                  <td>{{data.seriesValueTwoData}} </td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div [ngClass]="{'dispNone' : isRepairedByAssetTable}" id="bar-line-exited-chart"
          style="width: 1000px; height: 400px;">
        </div>
      </ion-col>


      <!-- </div> -->
    </div>
  </ion-col>
</ion-row>

<ion-row class="pt-10">
  <ion-col size="12">
    <div class="graphs card m-50">
      <ion-row class="justify-content-between">
        <ion-col size-sm="12" size-md="10" size-lg="10" size-xs="12" class="">
          <div class="fs-16 font_bold">Monthly attrition rate </div>
        </ion-col>
        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <div class="d-flex graph-icon">
            <span (click)="monthlyAttritionRate('bar')">
              <img *ngIf="ismonthlyAttritionRateIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
              <img *ngIf="ismonthlyAttritionRateIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
            </span>
            <span (click)="monthlyAttritionRateTable()">
              <img *ngIf="!ismonthlyAttritionRateTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
              <img *ngIf="ismonthlyAttritionRateTable" src="././assets/icon/TableIconActive.svg" alt="">
            </span>
            <span (click)="monthlyAttritionRate('line')">
              <img *ngIf="ismonthlyAttritionRateIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt=""
                class="cp">
              <img *ngIf="ismonthlyAttritionRateIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
            </span>
            <span>
              <img (click)="downloadChartAsPDF('Monthly attrition rate')" src="././assets/icon/downloadIcon.svg" alt=""
                class="cp">
            </span>
          </div>
        </ion-col>
      </ion-row>
      <!-- <ion-row class="">
        <ion-col size="5" size-md="5" size-lg="5" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col>
                  <div class="formLabelRegularfs16  ">
                    Year<span class="red-cl">&nbsp;*</span></div>
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                      (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col>
                  <div class="formLabelRegularfs16">
                    Month<span class="red-cl">&nbsp;*</span>
                  </div>
                  <mat-form-field class="mat-height40 w-100  mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedMonth"
                      (selectionChange)="onMonthChange($event)">
                      <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row> -->
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div [ngClass]="{'dispNone' : !ismonthlyAttritionRateTable}">
          <div class="dashboardGraphTable">
            <table id="monthly-data">
              <thead>
                <tr class="custom-size">

                  <th>Month</th>
                  <th>Exited Count</th>
                  <th>Attrition %</th>
                  <th>Annualized Attrition%</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of isMonthlyAttritionTableGraph">
                  <td>{{data.xAxisValueData}}</td>
                  <td>{{data.seriesValueOneData}} </td>
                  <td>{{data.seriesValueTwoData}}% </td>
                  <td>{{data.seriesValueThreeData}}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div [ngClass]="{'dispNone' : ismonthlyAttritionRateTable}" id="monthly-attrition-chart"
          style="width: 1000px; height: 400px;">
        </div>
      </ion-col>
    </div>
  </ion-col>
</ion-row>

<ion-row class="pt-10">

  <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
    <div class="graphs card m-50">
      <ion-row class="justify-content-center">
        <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
          <div class="fs-16 font_bold">Dept. Wise</div>
        </ion-col>

        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div class="d-flex graph-icon">
            <span (click)="departmentAttritionRate('bar')">
              <img *ngIf="isDepartmentAttritionRateIcon != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt=""
                class="cp">
              <img *ngIf="isDepartmentAttritionRateIcon == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
            </span>
            <span (click)="departmentAttritionRateTable()">
              <img *ngIf="!isDepartmentAttritionRateTable" src="./assets/icon/tableIcon.svg" alt="" class="cp">
              <img *ngIf="isDepartmentAttritionRateTable" src="./assets/icon/TableIconActive.svg" alt="">
            </span>
            <span (click)="departmentAttritionRate('line')">
              <img *ngIf="isDepartmentAttritionRateIcon != 'line'" src="./assets/icon/lineChartIcon.svg" alt=""
                class="cp">
              <img *ngIf="isDepartmentAttritionRateIcon == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
            </span>
            <span class="cp" (click)="departmentAttritionRate('pie')">
              <img src="./assets/icon/pieChartIcon.svg" *ngIf="isDepartmentAttritionRateIcon!='pie'">
              <img src="./assets/icon/activePieChartIcon.svg" *ngIf="isDepartmentAttritionRateIcon=='pie'">
            </span>
            <span>
              <img (click)="downloadChartAsPDF('Department-wise Attrition')" src="./assets/icon/downloadIcon.svg" alt=""
                class="cp">
            </span>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <!-- <div class="formLabelRegularfs16   mb-5">
                      Year<span class="red-cl">&nbsp;*</span></div> -->
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                      (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="4">
                  <!-- <div class="formLabelRegularfs16   mb-5">
                      Month<span class="red-cl">&nbsp;*</span>
                    </div> -->
                  <mat-form-field class="mat-height40 w-100  mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedMonth"
                      (selectionChange)="onMonthChange($event)">
                      <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                </ion-col>

              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>

      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <div [ngClass]="{'dispNone' : !isDepartmentAttritionRateTable}">
          <div class="dashboardGraphTable">
            <table id="table-Department-Attrition-data">
              <thead>
                <tr class="custom-size">
                  <th>Department</th>
                  <th>Count</th>
                  <th>Attrition%</th>
                  <th>Annualized Attrition%</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of isDepartmentAttritionTableGraph">
                  <td>{{data.xAxisValueData}}</td>
                  <td>{{data.seriesValueOneData}} </td>
                  <td>{{data.seriesValueTwoData}}% </td>
                  <td>{{data.seriesValueThreeData}}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div [ngClass]="{'dispNone' : isDepartmentAttritionRateTable}" id="department-attrition-chart"
          style="width: 500px; height: 400px;"></div>
      </ion-col>
    </div>
  </ion-col>
  <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
    <div class="graphs card m-50">
      <ion-row class="justify-content-center">
        <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
          <div class="fs-16 font_bold">Band Wise</div>
        </ion-col>

        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div class="d-flex graph-icon">
            <span (click)="bandAttritionRate('bar')">
              <img *ngIf="isBandAttritionRateIcon != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
              <img *ngIf="isBandAttritionRateIcon == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
            </span>
            <span (click)="bandAttritionRateTable()">
              <img *ngIf="!isBandAttritionRateTable" src="./assets/icon/tableIcon.svg" alt="" class="cp">
              <img *ngIf="isBandAttritionRateTable" src="./assets/icon/TableIconActive.svg" alt="">
            </span>
            <span (click)="bandAttritionRate('line')">
              <img *ngIf="isBandAttritionRateIcon != 'line'" src="./assets/icon/lineChartIcon.svg" alt="" class="cp">
              <img *ngIf="isBandAttritionRateIcon == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
            </span>
            <span class="cp" (click)="bandAttritionRate('pie')">
              <img src="./assets/icon/pieChartIcon.svg" *ngIf="isBandAttritionRateIcon!='pie'">
              <img src="./assets/icon/activePieChartIcon.svg" *ngIf="isBandAttritionRateIcon=='pie'">
            </span>
            <span>
              <img (click)="downloadChartAsPDF('Band-wise Attrition')" src="./assets/icon/downloadIcon.svg" alt=""
                class="cp">
            </span>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                      (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="4">
                  <mat-form-field class="mat-height40 w-100 mat-input-style">
                    <mat-select placeholder="Select Month" [(ngModel)]="selectedMonth"
                      (selectionChange)="onMonthChange($event)">
                      <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>

      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <div [ngClass]="{'dispNone' : !isBandAttritionRateTable}">
          <div class="dashboardGraphTable">
            <table id="table-Band-Attrition-data">
              <thead>
                <tr class="custom-size">
                  <th>Band</th>
                  <th>Count</th>
                  <th>Attrition%</th>
                  <th>Annualized Attrition%</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of isBandAttritionTableGraph">
                  <td>{{data.xAxisValueData}}</td>
                  <td>{{data.seriesValueOneData}} </td>
                  <td>{{data.seriesValueTwoData}}% </td>
                  <td>{{data.seriesValueThreeData}}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div [ngClass]="{'dispNone' : isBandAttritionRateTable}" id="band-attrition-chart"
          style="width: 500px; height: 400px;"></div>
      </ion-col>
    </div>
  </ion-col>

</ion-row>



<ion-row class="pt-10">
  <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
    <div class="graphs card m-50">
      <ion-row class="justify-content-center">
        <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
          <div class="fs-16 font_bold">Grade Wise</div>
        </ion-col>

        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div class="d-flex graph-icon">
            <span (click)="gradeAttritionRate('bar')">
              <img *ngIf="isGradeAttritionRateIcon != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
              <img *ngIf="isGradeAttritionRateIcon == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
            </span>
            <span (click)="gradeAttritionRateTable()">
              <img *ngIf="!isGradeAttritionRateTable" src="./assets/icon/tableIcon.svg" alt="" class="cp">
              <img *ngIf="isGradeAttritionRateTable" src="./assets/icon/TableIconActive.svg" alt="">
            </span>
            <span (click)="gradeAttritionRate('line')">
              <img *ngIf="isGradeAttritionRateIcon != 'line'" src="./assets/icon/lineChartIcon.svg" alt="" class="cp">
              <img *ngIf="isGradeAttritionRateIcon == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
            </span>
            <span class="cp" (click)="gradeAttritionRate('pie')">
              <img src="./assets/icon/pieChartIcon.svg" *ngIf="isGradeAttritionRateIcon!='pie'">
              <img src="./assets/icon/activePieChartIcon.svg" *ngIf="isGradeAttritionRateIcon=='pie'">
            </span>
            <span>
              <img (click)="downloadChartAsPDF('Grade-wise Attrition')" src="./assets/icon/downloadIcon.svg" alt=""
                class="cp">
            </span>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                      (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="4">
                  <mat-form-field class="mat-height40 w-100 mat-input-style">
                    <mat-select placeholder="Select Month" [(ngModel)]="selectedMonth"
                      (selectionChange)="onMonthChange($event)">
                      <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>

      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <div [ngClass]="{'dispNone' : !isGradeAttritionRateTable}">
          <div class="dashboardGraphTable">
            <table id="table-Grade-Attrition-data">
              <thead>
                <tr class="custom-size">
                  <th>Grade</th>
                  <th>Count</th>
                  <th>Attrition%</th>
                  <th>Annualized Attrition%</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of isGradeAttritionTableGraph">
                  <td>{{data.xAxisValueData}}</td>
                  <td>{{data.seriesValueOneData}} </td>
                  <td>{{data.seriesValueTwoData}}% </td>
                  <td>{{data.seriesValueThreeData}}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div [ngClass]="{'dispNone' : isGradeAttritionRateTable}" id="grade-attrition-chart"
          style="width: 500px; height: 400px;"></div>
      </ion-col>
    </div>
  </ion-col>


  <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
    <div class="graphs card m-50">
      <ion-row class="justify-content-center">
        <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
          <div class="fs-16 font_bold">State Wise</div>
        </ion-col>

        <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
          <div class="d-flex graph-icon">
            <span (click)="stateAttritionRate('bar')">
              <img *ngIf="isStateAttritionRateIcon != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
              <img *ngIf="isStateAttritionRateIcon == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
            </span>
            <span (click)="stateAttritionRateTable()">
              <img *ngIf="!isStateAttritionRateTable" src="./assets/icon/tableIcon.svg" alt="" class="cp">
              <img *ngIf="isStateAttritionRateTable" src="./assets/icon/TableIconActive.svg" alt="">
            </span>
            <span (click)="stateAttritionRate('line')">
              <img *ngIf="isStateAttritionRateIcon != 'line'" src="./assets/icon/lineChartIcon.svg" alt="" class="cp">
              <img *ngIf="isStateAttritionRateIcon == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
            </span>
            <span class="cp" (click)="stateAttritionRate('pie')">
              <img src="./assets/icon/pieChartIcon.svg" *ngIf="isStateAttritionRateIcon!='pie'">
              <img src="./assets/icon/activePieChartIcon.svg" *ngIf="isStateAttritionRateIcon=='pie'">
            </span>
            <span>
              <img (click)="downloadChartAsPDF('State-wise Attrition')" src="./assets/icon/downloadIcon.svg" alt=""
                class="cp">
            </span>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col size="4">
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                      (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="4">
                  <mat-form-field class="mat-height40 w-100 mat-input-style">
                    <mat-select placeholder="Select Month" [(ngModel)]="selectedMonth"
                      (selectionChange)="onMonthChange($event)">
                      <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>

      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <div [ngClass]="{'dispNone' : !isStateAttritionRateTable}">
          <div class="dashboardGraphTable">
            <table id="table-State-Attrition-data">
              <thead>
                <tr class="custom-size">
                  <th>State</th>
                  <th>Count</th>
                  <th>Attrition%</th>
                  <th>Annualized Attrition%</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of isStateAttritionTableGraph">
                  <td>{{data.xAxisValueData}}</td>
                  <td>{{data.seriesValueOneData}}</td>
                  <td>{{data.seriesValueTwoData}}%</td>
                  <td>{{data.seriesValueThreeData}}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div [ngClass]="{'dispNone' : isStateAttritionRateTable}" id="state-attrition-chart"
          style="width: 500px; height: 400px;"></div>
      </ion-col>
    </div>
  </ion-col>

</ion-row>


<ion-row class="pt-10">
  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
    <div class="graphs card m-50">
      <ion-row class="justify-content-between">
        <ion-col size-sm="12" size-md="10" size-lg="10" size-xs="12">
          <div class="fs-16 font_bold">How Are You Feeling Today?</div>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <div class="d-flex graph-icon">
            <span (click)="feelingRate('bar')">
              <img *ngIf="isFeelingRateIcon != 'bar'" src="./assets/icon/BarGraphIcon.svg" alt="" class="cp">
              <img *ngIf="isFeelingRateIcon == 'bar'" src="./assets/icon/BarGraphActive.svg" alt="">
            </span>
            <span (click)="feelingRateTable()">
              <img *ngIf="!isFeelingRateTable" src="./assets/icon/tableIcon.svg" alt="" class="cp">
              <img *ngIf="isFeelingRateTable" src="./assets/icon/TableIconActive.svg" alt="">
            </span>
            <span (click)="feelingRate('line')">
              <img *ngIf="isFeelingRateIcon != 'line'" src="./assets/icon/lineChartIcon.svg" alt="" class="cp">
              <img *ngIf="isFeelingRateIcon == 'line'" src="./assets/icon/activeLineChart.svg" alt="">
            </span>
            <!-- <span class="cp" (click)="feelingRate('pie')">
              <img src="./assets/icon/pieChartIcon.svg" *ngIf="isFeelingRateIcon!='pie'">
              <img src="./assets/icon/activePieChartIcon.svg" *ngIf="isFeelingRateIcon=='pie'">
            </span> -->
            <span>
              <img (click)="downloadChartAsPDF('Feeling Tracker')" src="./assets/icon/downloadIcon.svg" alt=""
                class="cp">
            </span>
          </div>
        </ion-col>
      </ion-row>

      <ion-row class="">
        <ion-col size="5" size-md="5" size-lg="5" size-xs="12">
          <div class="sidebar-content">
            <ion-grid>
              <ion-row>
                <ion-col>
                  <!-- <div class="formLabelRegularfs16  ">
                    Year<span class="red-cl">&nbsp;*</span></div> -->
                  <mat-form-field class="w-100 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                      (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                        {{sharedService.transformYearToFyFormat(item.year)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col>
                  <!-- <div class="formLabelRegularfs16">
                    Month<span class="red-cl">&nbsp;*</span>
                  </div> -->
                  <mat-form-field class="mat-height40 w-100  mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedMonth"
                      (selectionChange)="onMonthChange($event)">
                      <mat-option *ngFor="let month of arrAllMonths" [value]="month.key"> {{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-col>
      </ion-row>

      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div [ngClass]="{'dispNone' : !isFeelingRateTable}">
          <div class="dashboardGraphTable">
            <table id="table-Feeling-data">
              <thead>
                <tr class="custom-size">
                  <th>Mood</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of isFeelingTableGraph">
                  <td>{{data.xAxisValueData}}</td>
                  <td>{{data.seriesValueOneData}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div [ngClass]="{'dispNone' : isFeelingRateTable}" id="feeling-chart" style="width: 1000px; height: 400px;">
        </div>
      </ion-col>
    </div>
  </ion-col>

</ion-row>